export default "__VITE_ASSET__xPxQ5C5N__"